import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CheckOutlinedSvg from "@ant-design/icons-svg/es/asn/CheckOutlined";
import AntdIcon from "../components/AntdIcon";
var CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CheckOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CheckOutlined';
}
export default RefIcon;